export const PAGE_INDEX_HOME = 0;
export const PAGE_INDEX_SEGMENTS = 1;
export const PAGE_INDEX_ANALYTICS = 2;
export const PAGE_INDEX_DASHBOARDS = 3;
export const PAGE_INDEX_SYNC = 4;
export const PAGE_INDEX_TESTS = 5;
export const PAGE_RECOMMENDATION = 6;
